<div *ngIf="exibirBarraCor" style="background-color: rgb(0, 152, 223); height: 5px;"></div>
<div class="botoes-filtros">
  <div class="float-left">
    <button type="button" class="btn btn-danger mr-1" *ngIf="exibirBotaoVoltar" (click)="voltar();">
      <em class="fa fa-reply" aria-hidden="true"></em> <!--   fa fa-chevron-left   -->
    </button>
    <button translate type="button" class="btn mr-1" [class.btn-info]="!listagemComFiltros" *ngIf="exibirBotaoDefinirFiltros"
      [class.btn-warning]="listagemComFiltros" (click)="definirFiltragem();">
      {{'barraConsultaMensal.definirFiltros'}}
      <em class="fa fa-filter"></em>
    </button>
    <button translate type="button" class="btn btn-secondary mr-1" (click)="buscarRegistros();" *ngIf="exibirBotaoBuscar">
      {{'barraConsultaMensal.buscarDados'}}
      <em class="fa fa-search"></em>
    </button> {{bloquearBotaoNovoCadastro}}
  </div>
  <div class="float-right">
    <button *ngIf="detalhe" type="button" class="btn btn-info mr-1" (click)="detalhe.acao()" >
      <em [ngClass]="detalhe.icone" class="fa fa-calendar" aria-hidden="true"></em>
      {{detalhe.descricao}}
    </button>
    <button translate type="button" *ngIf="exibirNovo" class="btn btn-primary mr-1" (click)="criar();">
      <em class="fa fa-plus"></em>
      {{'barraConsultaMensal.novo'}}
    </button>
    
    <a translate class="btn btn-outline-info" *ngIf="exibirBotaoAjuda" href="http://ajuda.nbsi.com.br:84/" target="_blank">
      <em class="fa fa-question"></em>
      {{'barraConsultaMensal.ajuda'}}
    </a>
  </div>
  <div class="clear"></div>
</div>
